import styled from '@emotion/styled';
import { TextField } from '@material-ui/core';

export const SearchInputTextField = styled(TextField)`
  margin-left: 12px;
  min-width: 30% !important;
  width: 30% !important;
  height: 40px;

  .MuiInputBase-root {
    height: 100%;
    min-height: 40px;
  }

  .MuiInputBase-input {
    font-size: 13px;
    padding-right: 8px;
  }

  .MuiOutlinedInput-adornedStart {
    padding-left: 0;
  }

  .MuiOutlinedInput-adornedEnd {
    padding-right: 0;
  }

  .Mui-focused {
    .MuiSvgIcon-colorDisabled {
      color: #536171;
    }
  }
`;
